<template>
  <div>
    <!-- 关键字部分 -->
    <div class="pre_btn" v-show="show_key">
      <slot name="key_btn"></slot>
    </div>
    <!-- table部分 -->
    <div id="pre_tab" class="pre_tab" v-loading="fullloading" element-loading-text="拼命加载中......"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <table class="pre_dataintable_nokey2" border="1" cellpadding="2" cellspacing="1">
        <slot name="tab_title"></slot>
        <slot name="tab_tr" v-for="data_tr in data_tab" :item="data_tr"></slot>
        <slot name="tab_tr_all" :item="all_ammount"></slot>
      </table>
    </div>
    <!-- 分页部分 -->
    <div class="pre_page" v-show="show_page">
      <ul style="text-align: right; margin-right: 20px;">
        <li>
          当前页：<label>{{ nowpage }}</label>&nbsp; 合计页：<label>{{ maxpage }}</label>&nbsp;&nbsp; <a href="#"
            @click="firstpage">首页</a>|
          <a href="#" @click="beforepage">上一页</a>|
          <a href="#" @click="nextpage">下一页</a>|
          <a href="#" @click="lastpage">尾页</a>
          <input type="text" v-model="jumppage" value="" /><a href="#" @click="gopage" class="go">Go</a>
        </li>
      </ul>
    </div>
    <!-- 弹出向导层 start-->
    <div id="pop" class="pop" v-show="pop_show">
      <span class="pop_bg" @click="closeshow()"></span>
      <div id="pop_bodyup" class="pop_content">
        <div class="pop_head_close">
          <a class="close" href="javascript:void(0);" @click="hide()"></a>
        </div>
        <slot name="tab_addorupdate"></slot>
      </div>
    </div>
    <!-- 弹出向导层 end-->
  </div>
</template>
<script>
  /*
名称：Table组件 纯table+key
日期：2019-03-21
作者：hj

add 2020-11-08 替换等待提示和反馈提示为elementUI对应组件

确定为  自适应宽度
*/

  // import '@/assets/css/pop.css';

  import {
    BrowserGet
  } from '@/utils/systemSelect.js';
  // import '@/assets/css/pre_table2.css';
  export default {
    name: "pre_table_nokey",
    data() {
      return {
        data_tab: [],
        show_key: true,
        show_page: true,
        maxpage: '',
        nowpage: '',
        jumppage: '',
        fullloading: false,
        pop_show: false,
        show_btn_add: true,
        /*备份 上一次的查询方式，如果方式改变,则应该重新初始化page*/
        back_sel_type: '',
        sel_key: '',
        temp_scroll: 0,
        all_ammount: {}
      };
    },
    props: {
      api_url: String,
      pre_post: String,
      /* 需要 增 删 改 就绑定这个 */
      pre_post_upd: {
        type: String,
        default: ''
      },
      /* 操作标记 当保存操作是不关闭窗口,提交则关闭窗口 就绑定这个 */
      pre_action: {
        type: String,
        default: ''
      }
    },
    created: function() {
      this.nowpage = 1;
      this.chang_style();
      this.$nextTick(function() {
        $('html,body').animate({
          scrollTop: '0px'
        }, 500);
      })
      if (BrowserGet() == 'firefox') {
        this.temp_scroll = 24;
      }
    },
    watch: {
      pre_post(val) {
        this.loaddata();
      },
      pre_post_upd(val) {
        if (String(val) != '')
          this.neworupdate();
      }
    },
    mounted: function() {
      this.initTable();
      this.loaddata();
      const that = this;
      // 滚动事件 scroll
      // 变形事件 resize
      window.addEventListener('scroll', function() {
        that.chang_style(); //fixed 行相对位置修正
      }, false);
      // 这里只是操作dom
      window.addEventListener('resize', function() {
        that.chang_style(); //fixed 行相对位置修正
      }, false);

      // this.$set(this.ischeck, 'isok', '1')
    },
    methods: {
      initTable: function() {
        if (Number(this.maxpage) == 0 || Number(this.maxpage) == 1) {
          this.show_page = false;
        } else {
          this.show_page = true;
        }
      },
      chang_style: function() {
        this.$nextTick(function() {
          var screenWidth = $(window).width();
          // var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
          // var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
          let tw = 0,
            tleft = 0,
            tright = 0;
          tleft = $('#mleft').width();
          tright = $('#mright').width();
          tw = tright - 8;
          let css = '';
          css = 'width: ' + tw + 'px;max-width: ' + tw + 'px;';
          // console.log('左边宽度=' + tleft + '右边宽度=' + tright+'表格宽度=' + tw);
          // console.log(document.getElementById("mright"));
          // console.log($('#mright').width());

          var t = document.getElementById('pre_tab');
          // console.log(t);
          try {
            if (t == null) {
              // alert('11');
            } else {
              document.getElementById('pre_tab').style.cssText = css;
            }
          } catch (e) {}

        });
      },
      firstpage: function() {
        if (Number(this.nowpage) > 1) {
          this.nowpage = 1;
          this.refresh_data();
        } else {
          this.$message({
            message: '已经是第一页',
            type: 'warning'
          });
        }
      },
      beforepage: function() {
        if (Number(this.nowpage) > 1) {
          this.nowpage--;
          this.refresh_data();
        } else {
          this.$message({
            message: '已经是第一页',
            type: 'warning'
          });
        }
      },
      nextpage: function() {
        if (Number(this.nowpage) < Number(this.maxpage)) {
          this.nowpage++;
          this.refresh_data();
        } else {
          this.$message({
            message: '已经是最后一页',
            type: 'warning'
          });
        }
      },
      lastpage: function() {
        if (Number(this.nowpage) < Number(this.maxpage)) {
          this.nowpage = this.maxpage;
          this.refresh_data();
        } else {
          this.$message({
            message: '已经是最后一页',
            type: 'warning'
          });
        }
      },
      gopage: function() {

        if (Number(this.jumppage) > 0 && Number(this.jumppage) <= Number(this.maxpage)) {
          this.nowpage = this.jumppage;
          this.refresh_data();
        } else {
          this.$message({
            message: '跳转页数不在规定范围内,请检查' + this.jumppage,
            type: 'warning'
          });
        }
      },
      loaddata: function() {

        if (this.api_url == '' || this.pre_post == '') {
          // this.msg_obj = {
          //   'showtype': 'warning',
          //   'note': '请求数据不能空值'
          // };
          // console.log('请求数据不能空值' + '\r\n' + this.api_url + '\r\n' + this.pre_post);
          return;
        }

        this.fullloading = true;
        this.$post(
          this.api_url,
          this.pre_post
        ).then(res => {
          this.fullloading = false;
          this.data_tab = [];
          try {
            res = JSON.parse(res);
            if (Number.parseInt(res.data.status) == 1) {
              this.maxpage = res.data.allpage;
              if (Number(res.data.allpage) == 0) {
                this.$message({
                  message: '没有查询到数据',
                  type: 'success'
                });
              } else {
                // this.data_tab = res.data.data;
                let t = res.data.data;
                for (let i = 0; i < t.length; i++) {
                  let arr = [];
                  for (let j in t[i]) {
                    // console.log('key=' + j);       //输出key
                    // console.log('val=' + t[i][j]); //输出key对应的value
                    let o = {};
                    o.key = j;
                    if(typeof t[i][j]  === 'string' ){
                      o.val = t[i][j].replace(/<br\/>/g, '\n').replace(/\&nbsp\;/g, ' ');
                    }else{
                      o.val = t[i][j];
                    }

                    arr.push(o);
                  }
                  this.data_tab.push(arr);
                }

                // 返回合计字段
                // var o={};
                // o.allamount=res.data.allamount;
                // o.allamount_up=res.data.allamount_up;
                // o.allamount_yj=res.data.allamount_yj;
                // this.all_ammount=o;


                // 每次刷新 后默认 点击刚刚的修改项目,返回给个标记,返回到父组件,通过父组件保留的修改项目ID来刷新点击项目 2019-06-25
                // this.refresh_data('sel_ok',JSON.stringify(this.data_tab));


                // 每次刷新 后默认 点击第一行  同时也是  刚刚修改项目 add 2019-06-05
                // document.getElementById("tr1").click();          //不行
              }
            } else {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
            }
            this.initTable();
          } catch (ex) {
            this.$message({
              message: "查询失败" + ex,
              type: 'warning'
            });
          }
        });
      },
      refresh_data: function(action, tempdata) {
        // action   操作指示
        // tempdata 传输数据
        this.$emit("tab-event", action, this.nowpage, tempdata);
      },
      new_one_data: function() {
        this.data_tab.push({});
      },
      showpop: function() {
        this.pop_show = true;
        var Hg = $(document).height();
        // 设置背景高度
        $(".pop_bg").height(Hg);
        // 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
        $(".pop_bg").fadeIn("3000");
        $(".pop_content").fadeIn("3000");
      },
      hide: function() {
        this.pop_show = false;
        $(".pop_bg").fadeOut("3000");
        $(".pop_content").fadeOut("3000");
      },
      closeshow: function() {
        $(".pop_bg").fadeOut("3000");
        $(".pop_content").fadeOut("3000");
        // this.show_filedown=false;
      },
      neworupdate: function() {

        this.fullloading = true;
        this.$post(
          this.api_url,
          this.pre_post_upd,
        ).then(res => {
          console.log('查询.........');
          // if(Number(this.pre_action=='1')){ this.pop_show=false;}
          // add 2019-06-25 实现联动操作后就不需要关闭窗口了
          this.pop_show = false;

          try {
            res = JSON.parse(res);
            // console.log(res);
            if (res.data.status == 1) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });

              // console.log(res.data.new_id);
              let that = this;
              setTimeout(function() {
                let parm = '';
                parm = JSON.stringify({
                  "msg": res.data.msg,
                  "keyword": res.data.parm,
                  "new_id": res.data.new_id
                });

                that.refresh_data('upd_ok', parm);
              }, 100)

            } else {
              this.$message.error(res.data.msg);
            }
            this.fullloading = false;
            // this.refresh_data('sel');
            // this.initTable();
          } catch (ex) {
            this.fullloading = false;
            this.$message({
              message: "查询失败" + ex,
              type: 'warning'
            });
          }
        });
      },
      setCurrentRowJson: function(key, id) {
        // console.log('key=' + key + ' id=' + id );
        // console.log(this.data_tab);
        for (var i = 0; i < this.data_tab.length; i++) {
          // console.log(this.data_tab[i]);
          // console.log(this.data_tab[i][1]);
          if (this.data_tab[i][0].val % 2 == 0) {
            document.getElementById(key + this.data_tab[i][0].val).style.background = '#fff';
          } else {
            document.getElementById(key + this.data_tab[i][0].val).style.background = '#f5f5f5';
          }

          if (this.data_tab[i][0].val == id) {
            document.getElementById(key + id).style.background = '#92a4f3';
          }


        }
      },
    }
  };
</script>

<style scoped>
  /* pre_search */
  .pre_btn {
    text-align: left;
  }

  .pre_btn>label {
    position: relative;
    /* left: 2%; */
  }

  .pre_btn>input {
    position: relative;
    /* left: 2%; */
  }

  .pre_btn>input :focus {
    border: 1px solid #024aee;
    background-color: #aaa;
  }



  .pre_tab {
    padding-left: 12px;
    width: calc(100% -12px);
    overflow-x: auto;
    white-space: nowrap;
  }

  .pre_dataintable_nokey2 {
    margin-top: 3px;
    /* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
    table-layout: fixed;
    word-break: break-all;
    word-wrap: break-word;
    border-collapse: collapse;
    margin: 0;
    padding: 0;

  }

  .pre_dataintable_nokey2 td {
    padding: 2px 6px 2px 6px;
    vertical-align: middle;
    box-sizing: border-box;
    min-width: 48px;
    /* width: auto; */
    max-width: 256px;
    font-size: 14px;
    text-align: center;
    height: 24px;
    line-height: 22px;
    /* border: 1px solid #3f3f3f; */
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    /* 避免长单词截断，保持全部 */

    /* 换行 */
    /* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
  }

  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);

    text-align: center;
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    /* border: 1px solid #808080; */

  }

  /* 首列是ID,不排序,隐藏 */
  .pre_dataintable_nokey2 tr td:nth-child(1) {
    display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  }

  .pre_dataintable_nokey2 tr td:nth-child(2) {
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  }

  .pre_dataintable_nokey2 tr td:nth-last-child(1) {
    min-width: 168px;
    width: 168px;
  }

/*  .pre_dataintable_nokey2 .tab_header td:nth-last-child(2),
  .pre_dataintable_nokey2 .tab_body td:nth-last-child(2),
  .pre_dataintable_nokey2 .tab_header td:nth-last-child(1),
  .pre_dataintable_nokey2 .tab_body td:nth-last-child(1) {
    display: none;
  } */

  .tab_tr_all>td {
    vertical-align: baseline;
    padding: 2px 5px 2px 5px;
    background-color: rgb(134, 202, 219);
    border: 1px solid #3f3f3f;
    text-align: center;
    color: #000000;
    font-size: 16px;
    font-weight: bolder;
    height: 25px;
    line-height: 25px;
  }

  /* 表格内按钮 */
  .pre_dataintable_nokey2 td button {
    border: 1px solid #aaa;
    text-align: center;
    display: inline-block;
    margin-left: 2px;
    margin-right: 2px;
    cursor: pointer;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  /* 表格内输入框 */
  .pre_dataintable_nokey2 td input {
    width: 100%;
    height: 100%;
    border: 0px;
    text-align: left;
    padding: 2px 2px 2px 2px;
    /* font-size: 16px; */
  }

  .pre_dataintable_nokey2 td img {
    width: 24px;
    height: 24px;
    border: 0px;
    text-align: left;
    padding: 2px 2px 2px 2px;
    /* font-size: 16px; */
    margin-left: 5px;
    margin-right: 5px;
  }

  .pre_dataintable_nokey2 td img:hover {
    background: #aaa;
    /* font-size: 16px; */
  }

  .pre_dataintable_nokey2 td span {
    display: inline-block;
    border: 1px solid black;
    background: #aaa;
    text-align: center;
    padding: 2px 2px 2px 2px;
    /* font-size: 16px; */
    margin-left: 2px;
    margin-right: 2px;
  }

  .pre_dataintable_nokey2 tr:nth-child(odd) {
    background-color: #f5f5f5;
  }

  .pre_dataintable_nokey2 tr:nth-child(even) {
    background-color: #fff;
  }

  .pre_dataintable_nokey2 tr:hover {
    background-color: #B7D3F4 !important;
  }

  /*  .pre_dataintable_nokey2 tr:focus {
    background: #92a4f3 !important;
  } */
  /* 取消a标签的默认样式 */
  a {
    /* display: block; */
    height: 100%;
    text-decoration: none;
    color: #333;
  }

  .pre_dataintable_nokey2 tr>td>a:focus {
    background: #92a4f3 !important;
  }


  .tab_add {
    width: 95%;
    display: flex;
    margin-top: 5px;
    margin-left: 2%;
    background-color: rgba(103, 233, 77, 0.644);
  }

  .tab_upd {
    width: 95%;
    display: flex;
    margin-left: 2%;
    background-color: rgba(209, 212, 36, 0.644);
  }

  /* 翻页样式 */
  .pre_page {
    width: 100%;
    margin-top: 5px;
    /* padding-bottom: 5px; */
  }

  .pre_page>ul {
    text-align: right;
    list-style: none;
  }

  .pre_page>ul>li>label {
    width: 24px;
    min-width: 24px;
  }

  .pre_page>ul>li>input {
    width: 48px;
    min-width: 48px;
  }

  .pre_page>ul>li>a {
    text-decoration: none;
  }

  .pre_page>ul>li>.go {
    display: inline-block;
    width: 30px;
    height: 20px;
    border: 1px solid #cccccc;
    background: #024aee;
    color: #fff;
    border-radius: 4px;
    text-align: center;
    margin-left: 5px;
  }

  .pre_page>ul>li>a:hover {
    color: #394656;
  }
</style>
